import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input"]

    validate(event) {
        const password = this.inputTarget.value
        const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=\[\]{}|\\:";'<>?,.\/]).{8,}$/

        if (!pattern.test(password)) {
            this.inputTarget.setCustomValidity("Password must be at least 8 characters with uppercase, lowercase, digit, and special character")
            // this.inputTarget.reportValidity()
            // event.preventDefault()
        } else {
            this.inputTarget.setCustomValidity("")
        }
    }
}